/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const SPA_REFERRER_STORAGE_KEY = 'mbp_spa_referrer';
const EMPTY_REFERRER_STATE = {
    currentPath: '',
    previousPath: '',
};

const canUseSessionStorage = () => typeof window !== 'undefined' && typeof window.sessionStorage !== 'undefined';

const isPageReload = () => {
    if (typeof window === 'undefined' || !window?.performance || !window?.performance?.getEntriesByType) {
        return false;
    }

    const navigationEntries = window.performance.getEntriesByType?.('navigation') || [];
    if (navigationEntries.length) {
        return navigationEntries[0]?.type === 'reload';
    }

    return window.performance.navigation?.type === 1;
};

const getLocationOrigin = () => {
    if (typeof window === 'undefined' || !window.location?.origin) {
        return '';
    }

    return window.location.origin;
};

export const toAbsoluteUrl = (urlPath = '') => {
    if (!urlPath) {
        return '';
    }

    if (urlPath.includes('http:') || urlPath.includes('https:')) {
        return urlPath;
    }

    return `${getLocationOrigin()}${urlPath}`;
};

export const buildLocationPath = (location = {}) => {
    const locationPath = `${location.pathname || ''}${location.search || ''}${location.hash || ''}`;

    if (!locationPath) {
        return '';
    }

    return toAbsoluteUrl(locationPath);
};

export const getCurrentLocationPath = () => {
    if (typeof window === 'undefined' || !window.location) {
        return '';
    }

    return buildLocationPath(window.location);
};

export const readSpaReferrerState = () => {
    if (!canUseSessionStorage()) {
        return EMPTY_REFERRER_STATE;
    }

    try {
        const storedValue = sessionStorage.getItem(SPA_REFERRER_STORAGE_KEY);
        if (!storedValue) {
            return EMPTY_REFERRER_STATE;
        }

        return JSON.parse(storedValue);
    } catch (error) {
        return EMPTY_REFERRER_STATE;
    }
};

export const writeSpaReferrerState = (state) => {
    if (!canUseSessionStorage()) {
        return;
    }

    sessionStorage.setItem(SPA_REFERRER_STORAGE_KEY, JSON.stringify(state));
};

export const updateSpaReferrer = (location) => {
    const nextPath = buildLocationPath(location);

    if (!nextPath) {
        return;
    }

    const currentState = readSpaReferrerState();

    if (currentState.currentPath === nextPath) {
        return;
    }

    if (typeof window !== 'undefined') {
        window.gtmPvFired = false;
    }

    writeSpaReferrerState({
        currentPath: nextPath,
        previousPath: currentState.currentPath || '',
    });
};

export const getDocumentReferrer = () => {
    if (typeof document === 'undefined') {
        return undefined;
    }

    return document.referrer || undefined;
};

export const getPreviousLocation = () => {
    const { currentPath, previousPath } = readSpaReferrerState();
    const currentLocationPath = getCurrentLocationPath();

    if (isPageReload() && currentPath && currentPath === currentLocationPath && !getDocumentReferrer()) {
        return undefined;
    }

    if (currentPath && currentPath !== currentLocationPath) {
        return currentPath;
    }

    return previousPath || undefined;
};

export const getSpaReferrer = () => getPreviousLocation() || getDocumentReferrer() || undefined;
